<template>
    
    <v-data-table
	    :headers="computedHeaders"
	    :items="items"
	    @click:row="onRowClick"
	    hide-default-footer
	    :loading="loading"
	    :class="{ 'open-events-table': isOpenEventsTable }"
    >
	    <template v-for="(_, slot) in $slots" :key="slot" v-slot:[slot]="slotData">
		    <slot :name="slot" v-bind="slotData || {}"></slot>
	    </template>
	    <template #no-data>
		    <slot name="no-data"></slot>
	    </template>
    </v-data-table>
</template>

<script>
import TableBody from "@/components/tables/TableBody";
export default {
    props: {
        headers: {
            type: Array,
            required: true
        },
        items: {
            type: Array,
            required: true
        },
	    isOpenEventsTable: {
			type: Boolean
	    },
	    loading: {
		    type: Boolean
	    }

    },
    components: {
        TableBody
    },
    name: "AppSimpleTable",
    data () {
        return {

        }
    },
    computed: {
        // Convert Vuetify 2 header format (text/value) to Vuetify 3 format (title/key)
        computedHeaders() {
            return this.headers.map(h => {
                const { text, value, ...rest } = h
                return {
                    ...rest,
                    title: h.title || text,
                    key: h.key || value,
                }
            })
        }
    },
    methods: {
        // Vuetify 3: @click:row passes (event, { item }) instead of (item)
        onRowClick(event, { item }) {
            this.$emit('onRowClick', item)
        }
    }
}
</script>

<style scoped>
.app-simple-table-header {
    /*background-color: var(--v-light-base);*/

    /*color: white!important;*/
}

.app-simple-table-row:hover {
    background-color: var(--v-light-base)!important;
    cursor: pointer
}

.open-events-table :deep(thead) {
    background-color: #fb8c01;
}

.open-events-table :deep(thead th) {
    color: white !important;
}
</style>